module.exports = __webpack_public_path__ + "img/deactive-jabi-icon.e4d7e52f.svg";